import { NavContext } from '../components/dto/NavContext';

// Where the Back button of a details page goes. It is a stack, because a details page can open
// another details page (alert -> transaction -> terminal) and Back has to retrace those steps.
const STORAGE_KEY = 'nav_context';

function readStack(): NavContext[] {
    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (Array.isArray(parsed)) {
            return parsed;
        }
        // A single context, stored by an earlier version of the portal
        return parsed ? [parsed] : [];
    } catch (error) {
        console.log(error);
        return [];
    }
}

function writeStack(stack: NavContext[]): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stack));
    } catch (error) {
        console.log(error);
    }
}

// A list opens a details page: Back goes to that list, earlier steps are forgotten.
export function resetNavContext(context: NavContext): void {
    writeStack([context]);
}

// A details page opens another details page: Back there returns to this page.
export function pushNavContext(context: NavContext): void {
    writeStack([...readStack(), context]);
}

export function peekNavContext(): NavContext | null {
    const stack = readStack();
    return stack.length > 0 ? stack[stack.length - 1] : null;
}

// Back: returns where to go and removes it from the stack.
export function popNavContext(): NavContext | null {
    const stack = readStack();
    const context = stack.pop() ?? null;
    writeStack(stack);
    return context;
}
